module.exports = __webpack_public_path__ + "static/hexagons-right-2e86fdf4205a79aa34cc1335cd625250.png";